module.exports = __webpack_public_path__ + "img/sv65on.e8ff38af.svg";